<template>
    <div
        :class="[
            'loader',
            isLocked ? 'active' : '',
            !isInitComplete ? 'opaque' : '',
            isLoaderText ? 'text' : '',
        ]"
    >
        <img
            v-if="UtilityHelper.isOandaPath()"
            class="loader__gif"
            src="@/assets/oanda_loader.gif"
            alt=""
        />
        <svg v-else class="circular" viewBox="25 25 50 50">
            <circle
                class="path"
                cx="50"
                cy="50"
                r="20"
                fill="none"
                stroke-width="3"
                stroke-miterlimit="10"
            />
        </svg>
        <h2 v-if="isLoaderText && !isLoadingThumbnail">
            {{ $t(`${TRANSLATION_KEY}.pictureLoaderText`) }}
        </h2>
        <h2
            v-if="isLoaderText && isLoadingThumbnail"
            class="pt-200"
            v-html="$t(`${TRANSLATION_KEY}.pictureVerificationText`)"
        />
    </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { useStore } from 'vuex';
import { UtilityHelper } from '@/helpers/UtilityHelper';

export default defineComponent({
    name: 'Loader',
    setup() {
        const store = useStore();

        const isLocked = computed(() => store.state.isLocked);
        const isInitComplete = computed(() => store.state.isInitComplete);
        const isLoaderText = computed(() => store.state.isLoaderText);
        const isLoadingThumbnail = computed(
            () => store.state.isLoadingThumbnail
        );
        const TRANSLATION_KEY = 'Loader';

        return {
            isLocked,
            isInitComplete,
            isLoaderText,
            isLoadingThumbnail,
            TRANSLATION_KEY,
            UtilityHelper,
        };
    },
});
</script>

<style lang="scss" scoped>
.loader__gif {
    height: 150px;
    width: 150px;
}
</style>
